<template>
    <v-container tag="section">
        <v-row>
            <v-col class="pt-sm-8 pb-sm-8 pt-6">
                <h3 class="px-sm-9">{{ label }}</h3>
            </v-col>
        </v-row>
        <v-row>
            <v-col sm="6" cols="12" class="py-sm-0">
                <v-card height="100%" outlined tile flat class="v-card__borders-local--left pt-8">
                    <v-card-title class="px-4 px-sm-7 pt-0">
                        <h4 class="mb-0">
                            {{ mapConfig.mapTab1Header }}
                        </h4>
                    </v-card-title>
                    <v-card-text class="px-4 px-sm-7">
                        <ul>
                            <li v-for="item in tab1" :key="item.id">
                                {{ item.properties.title }}
                            </li>
                        </ul>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col sm="6" cols="12" class="py-sm-0">
                <v-card height="100%" outlined tile flat class="v-card__borders-local--left pt-8">
                    <v-card-title class="px-4 px-sm-7 pt-0">
                        <h4 class="mb-0">
                            {{ mapConfig.mapTab2Header }}
                        </h4>
                    </v-card-title>
                    <v-card-text class="px-4 px-sm-7">
                        <ul>
                            <li v-for="item in tab2" :key="item.id">
                                {{ item.properties.title }} - {{ item.properties.state }}
                            </li>
                        </ul>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: [
            'label'
        ],
        data() {
            return {
                mapData: []
            }
        },
        mounted() {
            this.$axios.get(this.$store.state.client_vars.MAP)
                .then(response => {
                    this.mapData = response.data.features
                })
                .catch(error => console.log('Failed to update from MOH', error))
        },
        computed: {
            mapConfig() {
                return this.$store.getters.getMapConfig
            },
            tab1() {
                let arr = this.mapData.reduce((a, i) => {
                    if(i.properties.type == "1") {
                        a.push(i)
                    }

                    return a
                }, [])

                return arr
            },
            tab2() {
                let arr = this.mapData.reduce((a, i) => {
                    if(i.properties.type == "2") {
                        a.push(i)
                    }

                    return a
                }, [])

                return arr
            }
        }
    }
</script>

<style scoped lang="scss">

    .v-card__text {

        li {
            font-size: 16px;
            font-weight: 500;
            line-height: 23px;
            color: var(--v-black-base);
        }
    }
</style>